export class IntermediarioEnlaceGeneral {
  public cod_Aplicacion: number;
  public cod_tipo_agente: number;
  public cod_agente: number;
  public estado: number;
  public fechaRegistro: Date;
  public cod_UsuarioSISE: string;

  constructor(
    cod_Aplicacion: number,
    cod_tipo_agente: number,
    cod_agente: number,
    estado: number,
    fechaRegistro: Date,
    cod_UsuarioSISE: string
  ) {
    this.cod_Aplicacion = cod_Aplicacion;
    this.cod_tipo_agente = cod_tipo_agente;
    this.cod_agente = cod_agente;
    this.estado = estado;
    this.fechaRegistro = fechaRegistro;
    this.cod_UsuarioSISE = cod_UsuarioSISE;
  }
}
